import { IGoogleCalendarEventBookingNotification } from '@/types/workflows/workflow-action/IWorkflowAction';

/**
 * Default configuration for a webinar.
 */
export const WF_ACTION_WEBINAR: IGoogleCalendarEventBookingNotification = {
	type: 'GoogleCalendarEventBookingNotification',
	addAttendees: true,
	addOrganizerAsAttendee: true,
	calendarId: '',
	colorId: '',
	createGoogleMeetBehaviour: {
		mode: 'ONLY_IF_ONLINE_LOCATION_IS_NEEDED',
		reuseOnlineConferenceIfPresent: true,
	},
	extraEmailAttendees: [],
	guestNotificationsMode: 'EXTERNAL_ONLY',
	guestsCanSeeOtherGuests: false,
	overlapBehaviour: 'UPDATE_ATTENDEES',
};
